import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleCliente } from "../hooks/roles/ProtectedRoleCliente";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const CuentaCompensacion = React.lazy(
  () => import("../screean/cuenta/cuenta-compensacion")
);
export function cuenta() {
  return (
    <Route
      path="/cuenta-clearing-detalle"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleCliente>
              <LazySuspense>
                <CuentaCompensacion />
              </LazySuspense>
            </ProtectedRoleCliente>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
